import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate } from '../api/dataverseClient';
import { AgentConfig, AgentSuggestion, AgentSuggestionStatus } from '../types';

export async function getAgentConfig(pca: IPublicClientApplication, projectId: string): Promise<AgentConfig | null> {
  const list = await dvList<AgentConfig>(pca, 'dagrun_pm_agentconfigs', {
    select: ['dagrun_pm_agentconfigid','dagrun_pm_name','dagrun_pm_autonomylevel','dagrun_pm_isenabled','dagrun_pm_atriskthresholdoverduetasks','dagrun_pm_atriskthresholdbudgetpct','dagrun_pm_askdagruntmscope','_dagrun_pm_projectid_value'],
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    top: 1,
  });
  return list[0] ?? null;
}

export async function createAgentConfig(pca: IPublicClientApplication, projectId: string): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_agentconfigs', {
    dagrun_pm_name: 'Project Agent Config',
    dagrun_pm_autonomylevel: 100000000, // Advisory
    dagrun_pm_isenabled: false,
    dagrun_pm_askdagruntmscope: 100000000, // ProjectWide
    dagrun_pm_atriskthresholdoverduetasks: 3,
    dagrun_pm_atriskthresholdbudgetpct: 110.0,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  });
}

export async function updateAgentConfig(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_agentconfigs', id, patch);
}

export async function getAgentSuggestions(pca: IPublicClientApplication, projectId: string): Promise<AgentSuggestion[]> {
  return dvList<AgentSuggestion>(pca, 'dagrun_pm_agentsuggestions', {
    select: ['dagrun_pm_agentsuggestionid','dagrun_pm_name','dagrun_pm_suggestiontype','dagrun_pm_suggestiontext','dagrun_pm_entitytype','dagrun_pm_entitytitle','dagrun_pm_status','_dagrun_pm_projectid_value'],
    filter: `_dagrun_pm_projectid_value eq ${projectId} and dagrun_pm_status eq ${AgentSuggestionStatus.Pending}`,
    top: 10,
  });
}

export async function resolveAgentSuggestion(pca: IPublicClientApplication, id: string, accept: boolean): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_agentsuggestions', id, {
    dagrun_pm_status: accept ? AgentSuggestionStatus.Accepted : AgentSuggestionStatus.Rejected,
  });
}
